import React, { useRef } from 'react';

import Img from '../../../../../components/Img';
import Modal from '../../../../../components/Modal';
import Avatar from '../../../../../components/Avatar';
import searchIcon from '../../../../../static/images/category/search_icon.png';
import heartIcon from '../../../../../static/images/category/heart_icon.png';
import cartIcon from '../../../../../static/images/category/cart_icon.png';
import styles from './PreviewCategoryModal.module.scss';

const PreviewCategoryModal = (props) => {
  const { setIsOpen, exhibitGeneralCategoryDataSource, exhibitEmphasisCategoryDataSource } = props;
  const emphasisCategoryEl = useRef(null);

  return (
    <Modal
      title="카테고리 전시 미리 보기"
      wrapClassName="preview-category-modal-wrapper"
      isOpen={true}
      width={400}
      height={700}
      padding={0}
      onOk={() => setIsOpen(false)}
      onClose={() => setIsOpen(false)}
    >
      <div className={styles.headerWrap}>
        <div className={styles.headerTitle}>카테고리</div>
        <div className={styles.headerIconWrap}>
          <Img src={searchIcon} clickAble={false} />
          <Img src={heartIcon} clickAble={false} />
          <Img src={cartIcon} clickAble={false} />
        </div>
      </div>
      <div className={styles.contentWrap}>
        <div className={styles.emphasisCategoryWrap}>
          <ul data-testid="emphasis-category" ref={emphasisCategoryEl}>
            {exhibitEmphasisCategoryDataSource.map((item) => (
              <li key={item.id}>
                <Avatar className="emphasis-category-img" src={item.categoryAttachments[0].url} alt={item.name} />
                <p>{item.name}</p>
              </li>
            ))}
          </ul>
        </div>
        <div className={styles.generalCategoryWrap}>
          <ul data-testid="general-category">
            {exhibitGeneralCategoryDataSource.map((item) => (
              <li key={item.id}>
                <p>{item.name}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Modal>
  );
};

export default PreviewCategoryModal;
